import { CampaignType, OperationType } from 'src/@types/valueMatching/enums';
import { API_ENDPOINTS } from 'src/routes/valueMatching/routes';

/**
 * Builds the URL for fetching campaign configuration for a given campaign type and operation type.
 *
 * @param campaignType - The campaign type to fetch configuration for
 * @param operationType - The operation type (e.g., CREATE_CAMPAIGN or MODIFY_CAMPAIGN)
 * @returns The full API endpoint URL for the campaign configuration
 */
export function buildCampaignConfigUrl(campaignType: CampaignType, operationType: OperationType): string {
    return `${API_ENDPOINTS.VALUE_MATCHING_CAMPAIGN_CONFIG}/${encodeURIComponent(campaignType)}/${encodeURIComponent(operationType)}`;
}
